module.exports = __webpack_public_path__ + "img/2.77902069.jpg";